<template>
<Tooltip transfer :content="validMsg" theme="err" :disabled="!(validErr&&validErrMsgTip)"  class="ivu-table-cell-tooltip">
    <div  :class="getEditClass" @mouseenter="validErrMsgTipIn" @mouseleave="validErrMsgTipOut">
        <div :class="[prefixCls + '-rel']">
            <template>
                <Tooltip transfer :content="content" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                    <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ content }}</p>
                </Tooltip>
            </template>
        </div>
        <template>
            <div
                :class="[prefixCls + '-popper']"
                v-if="visible">
                <div :class="[prefixCls + '-content']">
                    <Input ref="input" @on-change="change"  :disabled="disabled" @on-blur="blur" :value="content" type="textarea" :rows="2"/>
                </div>
            </div>
        </template>
    </div>
</Tooltip>
</template>
<script>
    const prefixCls = 'table-edit';
    import Tooltip from '../../tooltip/tooltip.vue';
    export default { 
        name: 'plugTextarea',
        components:{Tooltip},
        props: {
            content: {
                type: [String, Number],
                default: ''
            },
            col: [String, Number, Object],
            row: [String, Number, Object],
            editCfg: Object,
            disabled: {
                type: Boolean,
                default: false
            },
            visible: {
                type: Boolean,
                default: false
            },
            always: {
                type: Boolean,
                default: false
            },
            validErr:{
                type: Boolean,
                default: false
            },
            validMsg:String,
            editAlways:{
                type: Boolean,
                default: false
            },
            maxWidth: {
                type: [String, Number]
            }
        },
        data () {
            return {
                prefixCls: prefixCls,
                showTooltip: false,
                validErrMsgTip:false
            };
        },
        computed: {
            getEditClass() {
                return [
                    `${this.prefixCls}`,
                    {
                        [`${this.prefixCls}-always`]: (this.editAlways||this.always)&&!this.visible,
                        [`${this.prefixCls}-disabled`]:this.getDisabled(),
                        [`${this.prefixCls}-cell-valid-err`]: this.validErr === true&&!this.visible
                    }
                ];
            }
        },
        watch: {
            visible(newValue,oldValue){
                this.$nextTick(function(){
                    if(newValue)this.$refs.input.focus()
                })
            }
        },
        methods: {
            blur(){
                let value = event.target.value;
                this.$emit('onChangeShowEdit',false,value)
            },
            change(event){
                //先不让清空
                let value = event.target.value;
                if (this.number && value !== '') value = Number.isNaN(Number(value)) ? value : Number(value);
                if(value&&value!=""){
                    this.$emit('onChange',value,this.col)
                }
            },
            handleTooltipIn () {
                const $content = this.$refs.content;
                this.showTooltip = $content.scrollWidth > $content.offsetWidth;
            },
            handleTooltipOut () {
                this.showTooltip = false;
            },
            validErrMsgTipIn(){
                this.validErrMsgTip=true
            },
            validErrMsgTipOut(){
                this.validErrMsgTip=false
            },
            getDisabled(item) {
                let myDisabled=this.editCfg.setDisabled
                    ? this.editCfg.setDisabled(this.col, this.row, this.editCfg)
                    : this.editCfg.disabled;
                    if(myDisabled){
                        this.$emit("setColEditDisabled", myDisabled);
                    }
                    return myDisabled
            },
        },
        mounted () {
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/textarea.vue